import { graphql } from 'gql';

export const createProjectGql = graphql(`
    mutation createProject(
        $name: String!
        $stage: ProjectStageEnum!
        $status: ProjectStatusEnum!
        $methodology: ProjectMethodologyEnum!
        $contractType: ProjectContractTypeEnum!
        $code: String
    ) {
        createProject(
            projectInput: {
                name: $name
                stage: $stage
                status: $status
                methodology: $methodology
                contractType: $contractType
                code: $code
            }
        ) {
            data {
                uniqueId
                methodology
                name
                contractType
                stage
                subsidiary {
                    name
                }
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
